import axios, { AxiosError } from "axios";
const GeographicAreaResource = {
    get(geographicAreaId, resultFunc, errorFunc, finallyFunc) {
        axios.get(`/admin/v1/geographic-areas/${geographicAreaId}`)
            .then(response => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    },
    create(request, resultFunc, errorFunc, finallyFunc) {
        axios.post("/admin/v1/geographic-areas", request)
            .then(response => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    },
    update(geographicAreaId, request, resultFunc, errorFunc, finallyFunc) {
        axios.put(`/admin/v1/geographic-areas/${geographicAreaId}`, request)
            .then(response => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    },
};
export default GeographicAreaResource;
